import React from "react";

import NotificationCard from "components/NotificationCard";

export default ({ notifications, isLoading }) => {
  return (
    <div className="allNotifications">
      {notifications.map((notification, index) => (
        <NotificationCard key={notification.id} notification={notification} />
      ))}
      {!notifications.length && !isLoading && (
        <div className="noNotifcation">There is no notification</div>
      )}
    </div>
  );
};
